export const sesameReducer = (state = {loadingSesame: false, resultsesame: null, sesamedata: {}} , action) => {
    switch (action.type) {
        case 'SESAME_GET_SUCCESS':
            return {
                ...state,
                loadingSesame: false,
                sesamedata: action.payload
            }
        case 'SESAME_LOADING':
            return {
                ...state,
                loadingSesame:true
            }
        case 'SESAME_NOT_LOADING':
            return {
                ...state,
                loadingSesame: false
            }
        default:
            return state
    }
}

